import React from 'react';
import { InputLabel as MuiInputLabel } from '@mui/material';
import PropTypes from 'prop-types';

const InputLabel = ({ children, required, style, ...props }) => (
  <MuiInputLabel required={required} sx={{ fontSize: 14, fontWeight: 600, color: '#6d8994', ...style }} {...props}>
    {children}
  </MuiInputLabel>
);

InputLabel.propTypes = {
  children: PropTypes.node.isRequired,
  required: PropTypes.bool,
  style: PropTypes.object,
};

export default InputLabel;
